import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { GameDeffenseStore, GameHandPlayStore, GameStore, GlobalGameState } from "../../types/game";

export type SubscriptionState = {
  gameInfo: Partial<GameStore>;
  volume: boolean;
  updateGame: number;
  gameInfoHandPlay: Partial<GameHandPlayStore>;
  gameInfoDeffensePlay: Partial<GameDeffenseStore>;
  gameInfoTricksPlay: Partial<GameDeffenseStore>;
  gameInfoDefLeadPlay: Partial<GameDeffenseStore>;
  gameInfoMiniBridge: Partial<GameDeffenseStore>;
  subjectIdsHandPlay: string;
  subjectIdsDeffense: string;
  hideSolution: boolean;
  // It's created to cut some global props from games
  globalGameState: GlobalGameState;
  levels: string | null;
};

export const initialState: SubscriptionState = {
  gameInfo: {},
  volume: true,
  updateGame: 0,
  gameInfoHandPlay: {},
  gameInfoDeffensePlay: {},
  gameInfoTricksPlay: {},
  gameInfoDefLeadPlay: {},
  gameInfoMiniBridge: {},
  subjectIdsHandPlay: "",
  subjectIdsDeffense: "",
  hideSolution: true,
  globalGameState: {},
  levels: null
};

const coreSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setPlayerLevel(state, action: PayloadAction<string>) {
      state.levels = action.payload;
    },

    resetGame() {
      return initialState;
    },
    setHideSolutionsetGame(state, action: PayloadAction<boolean>) {
      state.hideSolution = action.payload;
    },
    setGame(state, action: PayloadAction<GameStore>) {
      state.gameInfo = action.payload;
      return state;
    },
    updateGame(state, action: PayloadAction<GameStore>) {
      state.gameInfo = {
        ...state.gameInfo,
        ...action.payload
      };
      return state;
    },
    setGlobalGameState(state, action: PayloadAction<GlobalGameState>) {
      state.globalGameState = {
        ...action.payload
      };
      return state;
    },
    updateGlobalGameState(state, action: PayloadAction<GlobalGameState>) {
      state.globalGameState = {
        ...state.globalGameState,
        ...action.payload
      };
      return state;
    },
    setVolume(state, action: PayloadAction<boolean>) {
      state.volume = action.payload;
      return state;
    },
    setUpdateGame(state) {
      state.updateGame += 1;
      return state;
    },
    setGameMultiple(
      state,
      action: {
        payload: {
          type_game: "bidding" | "handPlay" | "deffense" | "tricks" | "def_lead" | "mini_bridge";
          data: any;
        };
      }
    ) {
      switch (action.payload.type_game) {
        case "handPlay":
          state.gameInfoHandPlay = { ...action.payload.data };
          break;
        case "deffense":
          state.gameInfoDeffensePlay = { ...action.payload.data };
          break;
        case "tricks":
          state.gameInfoTricksPlay = { ...action.payload.data };
          break;
        case "def_lead":
          state.gameInfoDefLeadPlay = { ...action.payload.data };
          break;
        case "mini_bridge":
          state.gameInfoMiniBridge = { ...action.payload.data };
          break;
      }
      return state;
    },
    updateGameMultiple(
      state,
      action: {
        payload: {
          type_game: "bidding" | "handPlay" | "deffense" | "tricks" | "def_lead" | "mini_bridge";
          data: any;
        };
      }
    ) {
      switch (action.payload.type_game) {
        case "handPlay":
          state.gameInfoHandPlay = { ...state.gameInfoHandPlay, ...action.payload.data };
          break;
        case "deffense":
          state.gameInfoDeffensePlay = { ...state.gameInfoDeffensePlay, ...action.payload.data };
          break;
        case "tricks":
          state.gameInfoTricksPlay = { ...state.gameInfoTricksPlay, ...action.payload.data };
          break;
        case "def_lead":
          state.gameInfoDefLeadPlay = { ...state.gameInfoDefLeadPlay, ...action.payload.data };
          break;
        case "mini_bridge":
          state.gameInfoMiniBridge = { ...state.gameInfoMiniBridge, ...action.payload.data };
          break;
      }
      return state;
    },
    setSimpleField(
      state,
      action: { payload: { type: "subject_hand_play" | "subject_deffense_play"; value: any } }
    ) {
      switch (action.payload.type) {
        case "subject_hand_play":
          state.subjectIdsHandPlay = action.payload.value;
          break;
        case "subject_deffense_play":
          state.subjectIdsDeffense = action.payload.value;
      }
      return state;
    }
  }
});

export const {
  setPlayerLevel,
  resetGame,
  setGame,
  updateGame,
  setVolume,
  setUpdateGame,
  setGameMultiple,
  updateGameMultiple,
  setSimpleField,
  setHideSolutionsetGame,
  setGlobalGameState,
  updateGlobalGameState
} = coreSlice.actions;

export default coreSlice.reducer;
